import { PropsWithChildren, ReactNode } from "react";
import { cn } from "../../../utils/classes";
import styles from "./top-header.module.css";

export type TopHeaderProps = PropsWithChildren<{
  /** Typically a `<Breadcrumbs>`/`<Breadcrumb>` chain — see `components/breadcrumbs`. */
  breadcrumbs?: ReactNode;
  /** Global search slot, centred in the bar. */
  search?: ReactNode;
  /** Notifications slot, right-aligned. */
  notifications?: ReactNode;
  className?: string;
}>;

/**
 * The 48px top header bar (`design.md` "top-header"): breadcrumbs, global
 * search, and notifications slots. `children` renders alongside
 * `notifications` in the trailing action cluster for anything else page
 * chrome needs there.
 */
export function TopHeader({
  breadcrumbs,
  search,
  notifications,
  children,
  className,
}: TopHeaderProps) {
  return (
    <header className={cn(styles.header, className)}>
      {breadcrumbs && <div className={styles.breadcrumbs}>{breadcrumbs}</div>}
      {search && <div className={styles.search}>{search}</div>}
      {(notifications || children) && (
        <div className={styles.actions}>
          {notifications}
          {children}
        </div>
      )}
    </header>
  );
}
